// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"21c3294c","732":"acbda1f4","977":"e2e23422"}[chunkId] + ".chunk.js";
};